module.exports = __webpack_public_path__ + "src/modules/home/integration/integration.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/integration/integration.png
// module id = 1032
// module chunks = 0